import { PDFView } from '@modules/Landing/Shared/Ui/PDFView/PDFView';
import css from './LandingHeaderPDFViewPart.module.css';
import { IconWithTextWrapper } from '@modules/Landing/Shared/Ui/IconWithTextWrapper/IconWithTextWrapper';
import BillIcon from '@modules/Landing/Shared/Icons/BillIcon';
import BoardIcon from '@modules/Landing/Shared/Icons/BoardIcon';
import { EfficiencyPercentage } from '@modules/Landing/Shared/Ui/EfficiencyPercentage/EfficiencyPercentage';

export const LandingHeaderPDFViewPart: React.FC = () => {
    return (
        <section className={css.section}>
            <div className={css.pdf}>
                <PDFView />
            </div>
            <div className={css.getBill}>
                <IconWithTextWrapper
                    text={
                        'Get your Bill of Materials in PDF format in a few minutes'
                    }
                    icon={
                        <BillIcon
                            height={30}
                            width={30}
                            fill={'white'}
                            stroke={'var(--color-text-accent)'}
                            className={css.billIcon}
                        />
                    }
                />
            </div>
            <div className={css.tryTemplates}>
                {' '}
                <IconWithTextWrapper
                    text={'Try to use 20+ templates'}
                    icon={
                        <BoardIcon
                            width={30}
                            height={30}
                            fill={'var(--color-text-accent)'}
                        />
                    }
                />
            </div>
            <div className={css.statistic}>
                <EfficiencyPercentage />
            </div>
        </section>
    );
};
